import React from "react";
import { ArrowRight } from "lucide-react";

const categories = [
  {
    icon: "/biznep-mainsite/category-icons/restaurants.webp",
    title: "Restaurants",
    sub: "Food & Beverages",
    color: "#ef3038",
  },
  {
    icon: "/biznep-mainsite/category-icons/shopping.webp",
    title: "Shopping",
    sub: "Retail & Stores",
    color: "#3b82f6",
  },
  {
    icon: "/biznep-mainsite/category-icons/services.webp",
    title: "Services",
    sub: "Home & Professional",
    color: "#35c978",
  },
  {
    icon: "/biznep-mainsite/category-icons/health.webp",
    title: "Health",
    sub: "Medical & Wellness",
    color: "#8157e8",
  },
  {
    icon: "/biznep-mainsite/category-icons/beauty.webp",
    title: "Beauty",
    sub: "Salon & Personal Care",
    color: "#f59e0b",
  },
  {
    icon: "/biznep-mainsite/category-icons/education.webp",
    title: "Education",
    sub: "Learning & Training",
    color: "#2fc1cf",
  },
  {
    icon: "/biznep-mainsite/category-icons/automotive.webp",
    title: "Automotive",
    sub: "Auto & Repair",
    color: "#94a3b8",
  },
  {
    icon: "/biznep-mainsite/category-icons/more.webp",
    title: "More",
    sub: "And more...",
    color: "#8558ed",
  },
];

export default function Categories() {
  return (
    <section
      id="explore"
      className="
        w-full
        bg-[#fafbff]
        py-10
        sm:py-12
        lg:py-14
      "
    >
      <div
        className="
          mx-auto
          w-full
          max-w-[1400px]
          px-5
          sm:px-6
          lg:px-8
        "
      >
        {/* ================================================= */}
        {/* HEADER */}
        {/* ================================================= */}

        <div
          className="
            mb-8
            flex
            flex-col
            justify-between
            gap-5
            sm:flex-row
            sm:items-end
          "
        >
          <div>
            <h2
              className="
                mb-1
                text-[32px]
                font-extrabold
                leading-[1.15]
                tracking-[-0.8px]
                text-[#10203b]
                sm:text-[34px]
              "
            >
              Browse by Category
            </h2>

            <p
              className="
                text-[17px]
                leading-[1.45]
                text-[#64748b]
              "
            >
              Explore a wide range of local businesses near you.
            </p>
          </div>

          {/* View All Categories */}
          <button
            type="button"
            className="
              inline-flex
              w-fit
              shrink-0
              items-center
              gap-2
              whitespace-nowrap
              rounded-full
              border
              border-[#cbd9e8]
              bg-white
              px-5
              py-[9px]
              text-[15px]
              font-semibold
              text-[#0758b5]
              shadow-[0_1px_4px_rgba(7,88,181,0.04)]
              transition-all
              duration-200
              hover:border-[#0758b5]
              hover:bg-[#f8fbff]
            "
          >
            View All Categories

            <ArrowRight
              size={18}
              strokeWidth={2}
              className="text-[#0758b5]"
            />
          </button>
        </div>

        {/* ================================================= */}
        {/* CATEGORY GRID */}
        {/* ================================================= */}

        <div
          className="
            grid
            grid-cols-2
            gap-3
            sm:grid-cols-4
            sm:gap-4
            lg:grid-cols-8
            lg:gap-[14px]
          "
        >
          {categories.map((category) => (
            <div
              key={category.title}
              className="
                group
                flex
                h-[184px]
                cursor-pointer
                flex-col
                items-center
                rounded-[13px]
                border
                border-[#dfe6ee]
                bg-white
                px-2
                pt-[14px]
                text-center
                shadow-[0_2px_8px_rgba(40,70,100,0.035)]
                transition-all
                duration-200
                hover:-translate-y-[1px]
                hover:shadow-[0_5px_15px_rgba(40,70,100,0.08)]
              "
            >
              {/* ================================================= */}
              {/* COLORED CIRCLE */}
              {/* ================================================= */}

              <div
                className="
                  mb-[12px]
                  flex
                  h-[82px]
                  w-[82px]
                  shrink-0
                  items-center
                  justify-center
                  rounded-full
                  transition-transform
                  duration-200
                  group-hover:scale-[1.03]
                "
                style={{
                  backgroundColor: category.color,
                }}
              >
                {/* Exact reference icon */}
                <img
                  src={category.icon}
                  alt=""
                  className="
                    h-[48px]
                    w-[48px]
                    object-contain
                  "
                />
              </div>

              {/* ================================================= */}
              {/* TITLE */}
              {/* ================================================= */}

              <h3
                className="
                  mb-[3px]
                  text-[16px]
                  font-bold
                  leading-[1.15]
                  tracking-[-0.15px]
                  text-[#10203b]
                "
              >
                {category.title}
              </h3>

              {/* ================================================= */}
              {/* SUBTITLE */}
              {/* ================================================= */}

              <p
                className="
                  max-w-[150px]
                  text-[13px]
                  font-normal
                  leading-[1.25]
                  text-[#667085]
                "
              >
                {category.sub}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}